/* eslint-disable max-len */
/* eslint-disable no-throw-literal */
import _ from 'lodash';
import dayjs from 'dayjs';
import htmlParser from 'html-react-parser';
import { ERROR_CODE } from 'wmic-portals-utils-js';
import WMICTimezoneUtilService from './WMICTimezoneUtilService';

// TODO cleanup when implementing RQB-788
export default class WMICErrorHandlingService {
    static checkSessionUUID = (submissionDTO) => {
        if (submissionDTO === undefined || submissionDTO.sessionUUID === null || submissionDTO.sessionUUID === '') {
            // If a session UUID wasn't created, reject with an error message
            throw new Error('Error creating quote');
        }
    };

    static checkValidationError = (submissionDTO, checkUWIssues) => {
        if (submissionDTO != null && Array.isArray(submissionDTO.declineMessages_WMIC) && submissionDTO.declineMessages_WMIC.length > 0) {
            // Build structured issues and a legacy string for fallback
            const unique = new Set();
            const declineIssues = [];
            submissionDTO.declineMessages_WMIC.forEach((m) => {
                if (!m) return;
                const key = `${m.issueField}|${m.issueMessage}`;
                if (!unique.has(key)) {
                    unique.add(key);
                    declineIssues.push({ field: m.issueField, message: m.issueMessage });
                }
            });
            const declineMessage = declineIssues.map(i => i.message).join('\n');
            const residenceType = _.get(submissionDTO, 'lobData.homeowners.coverables.yourHome.residenceType');
            if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
            throw { code: ERROR_CODE.DECLINE, declineMessages: declineMessage, quoteID: submissionDTO.quoteID, residenceType };
        }
        // Fix for: saveAndQuote not returning decline messages to frontend
        // Now extracts issueMessage from each underwriting message and includes in error
        if (checkUWIssues && submissionDTO?.underwritingMessages) {
            // Extract issueMessage from each underwriting message in the array
            const declineMessages = Array.isArray(submissionDTO.underwritingMessages) 
                ? submissionDTO.underwritingMessages.map(m => m.issueMessage || m.message || '').filter(msg => msg)
                : [];
            const underwritingError = declineMessages.join('\n');  // Combine all messages for display
            console.log('Underwriting issues detected:', declineMessages);
            const uwResidenceType = _.get(submissionDTO, 'lobData.homeowners.coverables.yourHome.residenceType');
            if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
            throw { code: ERROR_CODE.UW_ISSUE, declineMessages: underwritingError, quoteID: submissionDTO.quoteID, residenceType: uwResidenceType };
        }
        if (submissionDTO !== undefined && !(submissionDTO.systemMessages_WMIC === undefined)) {
            // CUSTOMIZE : sjayakumar
            // CSS-548 : Error messages/code for delayed CLUE Report retrieval
            let systemMessage = '';
            let clueMessage = '';
            let paymentErrors = '';
            let consentErrors = '';
            let authorizationError = '';
            let dayTransitionError = '';
            let availabilityMessage = '';
            let twelvePayBindError = '';
            let invalidSessionError = '';
            let underwritingError = '';
            submissionDTO.systemMessages_WMIC.forEach((message) => {
                if (message.validationExceptionType === ERROR_CODE.CLUE_REPORT) {
                    clueMessage = `${clueMessage}${message.issueMessage}\n`;
                } else if (message.validationExceptionType === ERROR_CODE.PAYMENT) {
                    paymentErrors = `${paymentErrors}${message.issueMessage}\n`;
                } else if (message.validationExceptionType === ERROR_CODE.MARCONSENT || message.validationExceptionType === ERROR_CODE.OTWCONSENT) {
                    consentErrors  = `${consentErrors}${message.issueMessage}\n`;
                } else if (message.validationExceptionType === ERROR_CODE.AUTHORIZATION) {
                    authorizationError = `${authorizationError}${message.issueMessage}\n`;
                } else if (message.validationExceptionType === ERROR_CODE.DAY_TRANSITION) {
                    let newDate = `${WMICTimezoneUtilService.getDateInPolicyLocationTimeZone(submissionDTO.draftData.periodStartDate, 'yyyy-MM-dd')}T00:00:00Z`;
                    newDate = dayjs(newDate, 'MMMM d, yyyy').tz('UTC');
                    const dayTransitionMessage = `Your selected policy effective date is no longer available. The date in your quote has been updated to <strong>${newDate}</strong>. You can select a different policy effective date by <a ng-click="toDoYourInfo()"">returning to the Your Info page</a>.`;
                    dayTransitionError = htmlParser(dayTransitionMessage);
                } else if (message.validationExceptionType === ERROR_CODE.AVAILABILITY) {
                    availabilityMessage = `${availabilityMessage}${message.issueMessage}`;
                    _.set(submissionDTO, 'availabilityMessage', availabilityMessage);
                } else if (message.validationExceptionType === ERROR_CODE.TWELVE_PAY_BIND) {
                    twelvePayBindError = message.issueMessage;
                } else if (message.validationExceptionType === ERROR_CODE.INVALID_SESSION) {
                    invalidSessionError = `${invalidSessionError}${message.issueMessage}\n`;
                } else if (message.validationExceptionType === ERROR_CODE.INVALID_SUB_SESSION) {
                    invalidSessionError = `${invalidSessionError}${message.issueMessage}\n`;
                } else if (message.validationExceptionType === ERROR_CODE.UW_ISSUE) {
                    underwritingError = checkUWIssues ? `${underwritingError}${message.issueMessage}\n` : underwritingError;
                } else {
                    systemMessage = `${systemMessage}${message.issueMessage}\n`;
                }
            });
            if (systemMessage !== '') {
                // jmei - css370: Make error page aware of the quote ID
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.PORTAL_VALIDATION, systemMessages: systemMessage, quoteID: submissionDTO.quoteID, submissionData: submissionDTO };
            }
            if (invalidSessionError !== '') {
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.INVALID_SESSION, paymentErrors: invalidSessionError, quoteID: submissionDTO.quoteID };
            }
            if (paymentErrors !== '') {
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.PAYMENT, paymentErrors: paymentErrors, quoteID: submissionDTO.quoteID };
            }
            if (consentErrors !== '') {
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.CONSENT, paymentErrors: consentErrors, quoteID: submissionDTO.quoteID };
            }
            if (authorizationError !== '') {
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.AUTHORIZATION, paymentErrors: authorizationError, quoteID: submissionDTO.quoteID };
            }
            if (dayTransitionError !== '') {
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.DAY_TRANSITION, paymentErrors: dayTransitionError, quoteID: submissionDTO.quoteID };
            }
            if (clueMessage !== '') {
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.CLUE_REPORT, clueMessages: clueMessage, quoteID: submissionDTO.quoteID };
            }
            if (twelvePayBindError !== '') {
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.TWELVE_PAY_BIND, paymentErrors: twelvePayBindError, quoteID: submissionDTO.quoteID };
            }
            if (underwritingError !== '') {
                if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
                throw { code: ERROR_CODE.UW_ISSUE, declineMessages: underwritingError, quoteID: submissionDTO.quoteID };
            }
        }
    };

    static checkFailedRequestError = (errorResponse, quoteId, method) => {
        if (errorResponse?.baseError?.length > 0 && errorResponse?.baseError.toLowerCase().indexOf('invalid session') > -1) {
            if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
            throw { code: ERROR_CODE.INVALID_SESSION, paymentErrors: '', quoteID: quoteId };
        } else {
            if (typeof window !== 'undefined') { window.__wmicSkipRouteConfirm = true; }
            let technicalErrorCode = ERROR_CODE.TECHNICAL_ERROR;
            if (method === 'create') {
                technicalErrorCode = ERROR_CODE.TECHNICAL_ERROR_CREATE_QUOTE;
            } else if (method === 'retrieve' || method === 'retrieveAccountSubmission' || method === 'retrieveByOrder') {
                technicalErrorCode = ERROR_CODE.TECHNICAL_ERROR_RETRIEVE_QUOTE;
            } else if (method === 'updateDraftSubmission' || method === 'updateQuotedSubmission'
                || method === 'updateQuotedSubmissionWithLOBData' || method === 'updateDraftSubmissionAndPrimaryLocation'
                || method === 'saveAndQuote') {
                technicalErrorCode = ERROR_CODE.TECHNICAL_ERROR_UPDATE_QUOTE;
            }
            throw { code: technicalErrorCode, quoteID: quoteId };
        }
    };
}
